import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { SectionPanel } from 'ui/section-panel/section-panel';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { CodetableItemFormComponentProps } from 'app/area/codetable/item/codetable-item-form';
import { CodeActionType, SlotProps } from 'app/area/codetable/item/types';
import { ButtonPrimary } from 'ui';
import { SupportedListScreens } from 'app/area/codetable/list/list-renderer/supported-screens';
import { CodetableTranslation } from 'app/area/codetable/constants';
import styles from './risk-matrix-configuration.scss';

interface SubstanceLinksProps {
  rootId: number;
  addInfoText: (translation: CodetableTranslation) => string;
  editInfoText: (translation: CodetableTranslation) => string;
}

export const RiskMatrixConfiguration = (props: SubstanceLinksProps & Partial<CodetableItemFormComponentProps> & SlotProps) => {
  const { rootId, sectionRef, translation, actionType, addInfoText, editInfoText } = props;

  const riskMatrixAdministrationLink = () => navigate.toCodeList(rootId, SupportedListScreens.RiskMatrix);

  return <div ref={sectionRef}>
    <SectionPanel
      className="admin-paper-top-panel"
      componentId="risk-matrix-reminder-section"
      validation={undefined}
      info={{ text: editInfoText?.(translation), visible: actionType === CodeActionType.Edit }}
      label={{ visible: true, text: translation.risk_matrix_configuration }} />
    <MainGridContainer>
      <div className="row">
        <div className="col-md-12 mb-3">
          {actionType === CodeActionType.Edit
            ?
            <ButtonPrimary
              onClick={riskMatrixAdministrationLink}>
              {translation.risk_matrix}
            </ButtonPrimary>
            : <p className={`no-content ${styles.noContent}`}>{addInfoText?.(translation)}</p>}
        </div>
      </div>
    </MainGridContainer>
  </div>;
};
